module.exports = __webpack_public_path__ + "static/media/triple-sea.cc324e20.jpg";